import { ts, ts2 } from "src/utils/translate";
import { useDeleteMyProductMutation } from "src/api/v1/user-custom-items-ApiSlice";
import { customDevDeleted } from "src/components/Planner/planner/planner";
import { BaseDialog } from "src/components/BaseDialog/BaseDialog";

interface DeleteUserCustomItemDialogProps {
    onClose: () => void,
    productId: any | null,
    productName?: string,
}

export const DeleteUserCustomItemDialog = ({onClose, productId, productName}: DeleteUserCustomItemDialogProps) => {

    const [deleteMyProduct] = useDeleteMyProductMutation();

    const handleDeleteProduct = async () => {
        if (!productId) return;

        try {
            await deleteMyProduct({ user_custom_item_id: productId });
            customDevDeleted("user_custom_item_" + productId);

            onClose();
        } catch (error) {
            console.error('Törlés sikertelen:', error);
        }
    };

    return (
        <BaseDialog
            onClose={onClose}
            title={ts('delete_custom_item_title', "Delete custom item?")}
            cancelLabel={ts("planner_deletion_dialog_cancel_button_text", "Cancel")}
            actionLabel={ts("planner_deletion_dialog_action_button_text", "Delete")}
            onAction={handleDeleteProduct}
        >
            {ts2('user_custom_item_delete', "Are you sure you want to delete {userCustomItem} ?", {
                userCustomItem: productName ?? ''
            })}
        </BaseDialog>
    )
}